import { SvgIconBase } from '../utils/types';

export default function Logout({
  width = '20',
  height = '20',
  className = 'stroke-current',
}: SvgIconBase) {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Logout">
        <path
          id="Stroke 1"
          d="M11.5129 4.6579V3.8804C11.5129 2.18457 10.1379 0.80957 8.44207 0.80957H4.37957C2.68457 0.80957 1.30957 2.18457 1.30957 3.8804V13.1554C1.30957 14.8512 2.68457 16.2262 4.37957 16.2262H8.4504C10.1412 16.2262 11.5129 14.8554 11.5129 13.1646V12.3787"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Stroke 3"
          d="M17.1738 8.51774H7.13965"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Stroke 5"
          d="M14.7344 6.08838L17.1744 8.51755L14.7344 10.9475"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
